export enum TechniqueValuesEnum {
  Oil = 'oil', // Olej
  Acrylic = 'acrylic', // Akryl
  Watercolor = 'watercolor', // Akwarela
  Tempera = 'tempera', // Tempera
  Gouache = 'gouache', // Gwasz
  Collage = 'collage', // Kolaż
  Graffiti = 'graffiti', // Graffiti
  AirBrush = 'airBrush', // Air brush
  MixedTechnique = 'mixedTechnique', // Technika mieszana
  OwnTechnique = 'ownTechnique', // Technika własna
  Relief = 'relief', // Relief
  Tapestry = 'tapestry', // Gobelin
  Ceramics = 'ceramics', // Ceramika
  Sculpture = 'sculpture', // Rzeźba
  LostWaxCasting = 'lostWaxCasting', // Odlew techniką wosku traconego
  AppliedArt = 'appliedArt', // Sztuka użytkowa
  StainedGlass = 'stainedGlass', // Witraż
  Assemblage = 'assemblage', // Asamblaż
  BasRelief = 'basRelief', // Płaskorzeźba
  Photography = 'photography', // Fotografia
  DigitalArt = 'digitalArt', // Sztuka cyfrowa
  Etching = 'etching', // Akwaforta,
  Linocut = 'linocut', // Linoryt,
  Xylograph = 'xylograph', // Drzeworyt,
  Serigraphy = 'serigraphy', // Serigrafia
  Lithography = 'lithography', // Litografia
  DryNeedle = 'dryNeedle', // Sucha igła
  Giclee = 'giclee', // Giclee
  Pastel = 'pastel', // Pastel
  Video = 'video', // Video
  Drawing = 'drawing', // Rysunek
  Textile = 'textile', // Tkanina
  Other = 'other' // Inna
}
